import Vue from 'vue';
import {
  multicastSend
} from '../../../services/backendService/chatService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: []
};

// getters
const getters = {};

// actions
const actions = {
  async multicastSendHandler({}, data) {
    await multicastSend(data);
  }
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', data);
  },
  removeMemberList(state, index) {
    state.memberList.splice(index, 1);
  },
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
